module.exports = __webpack_public_path__ + "static/img/4.5454225.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/21/eng/4.png
// module id = SOEr
// module chunks = 0